export default __webpack_public_path__ + "static/media/banner-7.d6e8ae83.png";